import cx from "classnames"
import type React from "react"

export type CellPropsType = {
  children?: React.ReactNode
  divided?: boolean
  className?: string
}
export type CellSoftPropsType = {
  children?: React.ReactNode
  softDivided?: boolean
  className?: string
}

export type CellsPropsType = {
  content: CellPropsType["children"][]
} & Omit<CellPropsType, "children">
export type CellsSoftPropsType = {
  content: CellSoftPropsType["children"][]
} & Omit<CellSoftPropsType, "children">

function Cell(props: CellPropsType): React.JSX.Element
function Cell(props: CellSoftPropsType): React.JSX.Element
function Cell({
  children,
  divided,
  softDivided,
  className,
}: CellPropsType & CellSoftPropsType): React.JSX.Element {
  return (
    <div
      className={cx("cobalt-cell", className, {
        "cobalt-cell--divided": divided,
        "cobalt-cell--softDivided": softDivided,
      })}
    >
      {children}
    </div>
  )
}

export function Cells(props: CellsPropsType): React.JSX.Element
export function Cells(props: CellsSoftPropsType): React.JSX.Element
export function Cells({
  content,
  ...cellProps
}: CellsPropsType & CellsSoftPropsType): React.JSX.Element {
  return (
    <>
      {content.map((c, i) => (
        <Cell
          key={`cell-${i}-${typeof c === "string" || typeof c === "number" ? c : "unknown-value"}`}
          {...cellProps}
        >
          {c}
        </Cell>
      ))}
    </>
  )
}

export default Cell
